module.exports = __webpack_public_path__ + "b27d4957c081f5f8b8873d6fcd8f551d.MP3";